import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl px-6 lg:px-8" }
const _hoisted_2 = { class: "rounded-xl shadow-lg overflow-hidden border border-gray-200" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "flex flex-col h-full" }

import { computed } from "vue";
import type { ActionsWithSharedBordersProps } from "./tables.interfaces";
import SectionContainer from "@/views/blocks/shared/section/container/SectionContainer.vue";
import Title from "@/views/blocks/tables/shared/title/Title.vue";
import Description from "@/views/blocks/tables/shared/description/Description.vue";
import Icon from "@/views/blocks/tables/shared/icon/Icon.vue";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import EditableElement from "@/views/page/EditableElement.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ActionsWithSharedBorders',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionContainer, {
    id: "actions-with-shared-borders",
    class: "lg:px-8 px-6",
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.actions.data.items, (action, index) => {
              return (_openBlock(), _createBlock(EditableElement, {
                key: action.id,
                blockId: _ctx.block.id,
                "field-name": `actions_${action.id}`,
                hideable: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: action.link,
                    target: "_blank",
                    rel: "noopener",
                    class: _normalizeClass([
                                'group relative p-8 cursor-pointer',
                                'border-b border-gray-200 sm:border-r',
                                'focus:outline-none focus:ring-2 focus:ring-inset',
                                {
                                    'sm:border-r-0': index % 2 === 1,
                                    'rounded-t-xl sm:rounded-tl-xl sm:rounded-tr-none': index === 0,
                                    'sm:rounded-tr-xl sm:rounded-tl-none': index === 1,
                                    'rounded-b-xl':
                                        index === dataValues.value.actions.data.items.length - 1,
                                    'sm:rounded-bl-xl sm:rounded-br-none sm:border-b-0':
                                        (index === dataValues.value.actions.data.items.length - 2 &&
                                            dataValues.value.actions.data.items.length % 2 === 0) ||
                                        (index === dataValues.value.actions.data.items.length - 1 &&
                                            dataValues.value.actions.data.items.length % 2 === 1),
                                    'rounded-b-xl sm:rounded-br-xl sm:rounded-bl-none border-b-0':
                                        index === dataValues.value.actions.data.items.length - 1 &&
                                        dataValues.value.actions.data.items.length % 2 === 0,
                                },
                            ]),
                    style: _normalizeStyle({
                                '--tw-ring-color': styleValues.value.brand,
                                backgroundColor: styleValues.value.background,
                            })
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(Icon, {
                        src: action.imageSrc,
                        alt: action.imageAlt,
                        backgroundColor: styleValues.value.brand,
                        class: "mb-8"
                      }, null, 8, ["src", "alt", "backgroundColor"]),
                      _createVNode(Title, {
                        text: action.title,
                        textColor: styleValues.value.text,
                        class: "mb-2"
                      }, null, 8, ["text", "textColor"]),
                      _createVNode(Description, {
                        text: action.description,
                        textColor: styleValues.value.text
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("span", {
                      class: "pointer-events-none absolute right-8 top-8 text-gray-300 group-hover:text-gray-400",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", { d: "M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" })
                      ])
                    ], -1))
                  ], 14, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["blockId", "field-name"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["backgroundColor"]))
}
}

})